import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import * as _redux from './setup'
import store from './setup/redux/Store'

// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'

// Apps
import {App} from './app/App'
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'

// SSO / Keycloak cutover (feature-flagged — off = legacy behavior unchanged)
import {AuthProvider as SsoAuthProvider} from '@be-infinity-ltd/auth-react'
import {SSO_ENABLED, authConfig} from './setup/keycloak/authConfig'

// The shared package is typed for React 18 (components may return `ReactNode`);
// this app is on React 17 (JSX expects `ReactElement | null`). The component is
// runtime-valid, so we adapt only its type here — no behavioral change.
const AuthProvider = SsoAuthProvider as React.FC<{
  config: typeof authConfig
  children: React.ReactNode
}>

const {PUBLIC_URL} = process.env
_redux.setupAxios(axios, store)

// SSO: legacy redux actions navigate to /auth/login (via window.open) when a backend returns
// `auth:false`. Under SSO the Keycloak session is authoritative and there is no /auth/login page,
// so a not-yet-dual-mode backend's `auth:false` must not bounce us to login (that caused a loop).
if (SSO_ENABLED) {
  const _open = window.open.bind(window)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.open = ((url?: any, ...rest: any[]) => {
    if (typeof url === 'string' && url.indexOf('/auth/login') !== -1) return null
    return _open(url, ...(rest as [any, any]))
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) as any
}

Chart.register(...registerables)

const appTree = (
  <MetronicI18nProvider>
    <Provider store={store}>
      <App basename={PUBLIC_URL} />
    </Provider>
  </MetronicI18nProvider>
)

ReactDOM.render(
  SSO_ENABLED ? <AuthProvider config={authConfig}>{appTree}</AuthProvider> : appTree,
  document.getElementById('root')
)
